// extracted by mini-css-extract-plugin
export default {"container":"styles_container__USFNl","container__body":"styles_container__body__Y9Owx","container__body__padding":"styles_container__body__padding__fp7Hw"};